import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/hooks/useAuth";
import {
  opsReviewHomePath,
  resolvePreFlightScriptsAccess,
} from "@/features/auth/lib/assert-pre-flight-scripts-access";
import { ScriptReviewDetailPage } from "@/features/script-review/pages/ScriptReviewDetailPage";
import { scriptReviewDetailQueryOptions } from "@/lib/queries";

export const Route = createFileRoute("/_authenticated/pre-flight-scripts/review/$reviewId")({
  loader: ({ context, params }) => {
    const tenantId = useAuth.getState().activeTenantId;
    if (!tenantId) return null;
    return context.queryClient
      .ensureQueryData(scriptReviewDetailQueryOptions(tenantId, params.reviewId))
      .catch(() => null);
  },
  component: ScriptReviewDetailRoute,
});

function ScriptReviewDetailRoute() {
  const { reviewId } = Route.useParams();
  const navigate = useNavigate();
  const activeTenantId = useAuth((s) => s.activeTenantId);
  const tenants = useAuth((s) => s.tenants);
  const access = resolvePreFlightScriptsAccess(tenants, activeTenantId);
  const isPartnerPortalUser = access === "partner-review";
  const isClientReviewMode = access === "marketplace-review";
  const isOpsReview = access === "ops-review";

  return (
    <ScriptReviewDetailPage
      reviewId={reviewId}
      readOnly={isPartnerPortalUser}
      clientReviewMode={isClientReviewMode}
      onBack={() => {
        if (isPartnerPortalUser) {
          void navigate({ to: "/marketplace/partner" });
          return;
        }
        if (isOpsReview) {
          if (typeof window !== "undefined" && window.history.length > 1) {
            window.history.back();
            return;
          }
          const home = opsReviewHomePath(access);
          if (home) void navigate({ to: home });
          return;
        }
        if (
          isClientReviewMode &&
          typeof window !== "undefined" &&
          window.history.length > 1
        ) {
          window.history.back();
          return;
        }
        void navigate({ to: "/pre-flight-scripts" });
      }}
      onOpenVersion={(id) =>
        void navigate({ to: "/pre-flight-scripts/review/$reviewId", params: { reviewId: id } })
      }
    />
  );
}
